<template>
  <div class="reviewDetail">
    <ots-main-title></ots-main-title>
    <div class="detail-title">
      <span class="font-color-gary font-size-13">考试批次：</span>
      <span class="font-size-20 margin-rignt-64">{{reviewDetail.planName}}</span>
      <span class="font-color-gary font-size-13">考试课程：</span>
      <span class="font-size-20 margin-rignt-8">{{reviewDetail.courseName}}</span>
      <!-- <el-dropdown trigger="click">
        <span class="el-dropdown-link">
          <img :src="courseImg" alt="">
        </span>
        <template #dropdown>
          <el-dropdown-menu >
            <el-dropdown-item v-for="(item, index) in courseList" :key="index" @click.native="changCourse(item)">{{item.courseName}}</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown> -->
    </div>
    <ots-table-group-new
      :selectList="selectList"
      :requestForm="requestForm"
      :tableHeader="tableHeader"
      :tableData="tableData"
      :pagination="pagination"
      @changeNum="changeNum"
      @changePage="changePage"
    >
    </ots-table-group-new>
  </div>
</template>

<script>
import { getPlanCourseFn } from "@/http/modules/baseSet/course";
import { getReviewList, getUrl } from "@/http/modules/markPaper";
import { getOtsUrlFn } from '@/http/modules/examSet/score';

export default {
  data() {
    return {
      selectList: [],
      requestForm: {
        planId: "",
        courseId: "",
        page: 1,
        size: 10,
      },
      tableHeader: [
        {
          title: "学生",
          prop: "realName"
        },
        {
          title: "证件号",
          prop: "cardNo"
        },
        {
          title: "考试活动",
          prop: "arrangementName"
        },
        {
          title: "试卷名称",
          prop: "paperName"
        },
        {
          title: "评阅状态",
          prop: "reviewState"
        },
        {
          title: "评阅时间",
          prop: "reviewTime"
        },
        {
          title: "成绩",
          prop: "score"
        },
        {
          title: "操作",
          type: "buttons",
          width: "160",
          fixed: "center",
          btnList: [
            {
              title: "复评",
              click: this.secondGuess,
              formatter: (scope) => {
                return scope.row.canReview == "0";
              },
            },
            {
              title: "查看",
              click: this.searchScore,
            },
          ],
        },
      ],
      tableData: [],
      pagination: {
        total: 10,
      },
      courseImg: require('@/assets/img/courseChange.png'),
      reviewDetail: this.$route.query,
      courseList: [],
    }
  },

  mounted(){
    this.search();
    this.getCourseList();
  },

  methods: {
    search(){
      let params = { ...this.requestForm }
      params.planId = this.$route.query.planId;
      params.courseId = this.$route.query.courseId;
      params.arrangementId = this.$route.query.arrangementId
      getReviewList(params).then(res=>{
        if (res.code == 1) {
          console.log(res);
          this.tableData = res.data.records;
          this.pagination.total = res.data.total;
        }
      })
    },

    getCourseList(){
      let params = {
        planId: this.$route.query.planId
      }
      getPlanCourseFn({planId: params.planId}).then( res => {
        if (res.code == 1) {
          this.courseList = res.data;
        }
      })
    },
    // changCourse(course){
    //   this.reviewDetail.courseName = course.courseName;
    //   let params = { ...this.requestForm }      
    //   params.planId = this.$route.query.planId;
    //   params.courseId = course.courseId;
    //   getReviewList(params).then( res => {
    //     if (res.code == 1) {
    //       this.tableData = res.data.records;
    //       this.pagination.total = res.data.total;
    //     }
    //   })
    // },
    async searchScore(row){
      let params = {
        action: 'getTReviewDetails',
        parames: `argumentsId=${row.recordId}&curPage=JudgeLib`
      }
      const { code, data } = await getOtsUrlFn(params)
      if (code==1) {
        window.open(data)
      }
    },

    /**
     * @param { 复评 }
     */
    secondGuess(row) {
      let params = {
        arrangementId: this.$route.query.arrangementId,
        recordId: row.recordId
      }
      getUrl(params).then(res=>{
        if (res.code == 1) {
          window.open(res.data);
        }
      })

    },

    /***********************
     * @this 分页-每页数量
     **********************/
    changeNum(num) {
      this.requestForm.size = num;
      this.search();
    },

    /***********************
     * @this 分页-页码
     **********************/
    changePage(p) {
      this.requestForm.page = p;
      this.search();
    },
  }
}
</script>

<style lang="less" scoped>
.margin-rignt-64 {
  margin-right: 64px;
}
.margin-rignt-8 {
  margin-right: 8px;
}
.font-color-gary {
  color: #9299A6;
}
.font-size-13 {
  font-size: 13px;
}
.font-size-20 {
  font-size: 20px;
  font-weight: 500;
  color: #2D2F33;
}
.reviewDetail {
  .detail-title {
    padding: 0 32px;
    box-sizing: border-box;
    width: 100%;
    background-color: #EBF0FA;
    height: 64px;
    border-radius: 8px 8px 0px 0px;
    display: flex;
    justify-content: left;
    align-items: center;
  }
}

.el-dropdown {
  width: 50px;
  height: 20px;
}
.el-dropdown-link {
  cursor: pointer;
  color: var(--el-color-primary);
  display: flex;
  align-items: center;
}
</style>